import { useEffect, useLayoutEffect, useState } from "react";

// router
import { useNavigate, useParams } from "react-router-dom";

// bootstrap
import { Container, Form } from "react-bootstrap";

// componentes
import Migas from "../migasGeomedellin/Migas";
import PiePagina from "../piePagina/PiePagina";
import Rating from "../../common/Rating";
import Load from "../../common/Load";

// http services request
import getDatos from "../../../services/getDatos";
import registrarEstadistica from "../../../services/estadistica";

// Variables globales
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

// custom hooks
import { usePermisions } from "../../../hooks/usePermisions";
import consultarInfoToken from "../../../services/consultarInfoToken";
import encode64 from "../../../helpers/encode64";
import getAuthUrl from "../../../services/getAuthUrl";

export const InfoDatosAbiertos = ({
  idComponente,
  caracFiltro,
  imagen,
  descripcion,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();

  // data openData
  const [openDataInfo, setOpenDataInfo] = useState([]);

  const [descargas, setDescargas] = useState([]);

  const [visitas, setVisitas] = useState([]);

  // Load
  const [load, setLoad] = useState(false);
  const [dataUser, setDataUSer] = useState({});

  useEffect(() => {
    getDataUser();
  }, []);

  const getDataUser = async () => {
    let result = await consultarInfoToken();
    setDataUSer(result);
  };

  const obtenerOpenData = async () => {
    setLoad(true);
    try {
      let infoToken = await consultarInfoToken();
      const responseOpenData = await getDatos(`opendata/${id}`, {
        info: encode64(JSON.stringify(infoToken)),
      });

      // guardarUbicacion("2", "2", id);

      setOpenDataInfo(responseOpenData);
    } catch (err) {
      alert("Error");
      navigate("/datosAbiertos");
    } finally {
      setLoad(false);
    }
  };

  const obtenerEstadistica = async () => {
    setLoad(true);
    try {
      const descargas = await getDatos(`opendata/estadistica/${id}/1`);

      const visitas = await getDatos(`opendata/estadistica/${id}/2`);

      setDescargas(descargas);
      setVisitas(visitas);
    } catch (err) {
      alert("Error");
      navigate("/datosAbiertos");
    } finally {
      setLoad(false);
    }
  };

  const redireccionMetadato = (vinculo, uuid) => {
    if (uuid) {
      window.open(vinculo, "_blank");
    } else {
      return false;
    }
  };

  const urlDescargaFormatos = (formato, id_servicio) => {
    const urlNombreArchivo = formato.split("--")[3];

    if (!urlNombreArchivo) {
      return false;
    }

    if (
      id_servicio &&
      urlNombreArchivo.includes("https://www.medellin.gov.co/")
    ) {
      return urlNombreArchivo;
    }

    return `${URL_IMAGE_GEOMEDELLIN}/openDataExt/${urlNombreArchivo}`;
  };

  const mostrarImgDatoAbierto = (infoDatoAbierto) => {
    const { externo, imagen_ext, id_fuente_dato, imagen } = infoDatoAbierto;

    if (externo && imagen_ext) {
      return imagen_ext;
    }

    if (imagen?.includes("https://www.medellin.gov.co/")) {
      return imagen;
    }

    return `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Datos_abiertos/${id_fuente_dato}/${imagen}`;
  };

  const obtenerUrl = async () => {
    setLoad(true);
    try {
      let resultUrl = await getAuthUrl(id, dataUser.idUsuario);
      if (resultUrl.success) {
        let data = [...openDataInfo];
        data[0].url_servicio = resultUrl.message.url;
        setOpenDataInfo(data);
      } else {
        alert(resultUrl.message);
      }
    } catch (err) {
      alert("Error");
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const { infoUser } = usePermisions(idComponente);

  useLayoutEffect(() => {
    obtenerOpenData();
    obtenerEstadistica();
    window.scroll(0, 0);
  }, [id]);

  return (
    <>
      <Container fluid={true} className="content-datosabiertos">
        <div
          className="img-logo-datosabiertos"
          style={{
            backgroundImage: `url("${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Banner/${idComponente}/${imagen}")`,
          }}
        >
          <div className="content-degradado">
            <div className="content-contendido-img-banner">
              <label className="lblitulo-txt-imgbanner">Datos abiertos</label>
              <p>
                <label className="lbdescripcion-txt-imgbanner">
                  {descripcion}
                </label>
              </p>
            </div>
          </div>
          <label className="color-borde-img-banner"></label>
        </div>
        <Migas ruta="Datos abiertos" />

        <Container>
          <div className="grid-container-info-opendata">
            {openDataInfo.map((metadato) => {
              return (
                <div
                  className="flex-container-section-one"
                  key={metadato?.id_opendata}
                >
                  <div className="img-info-estado-section-one">
                    <img
                      src={mostrarImgDatoAbierto(metadato)}
                      alt={
                        metadato?.externo
                          ? metadato?.imagen_ext
                          : metadato?.imagen
                      }
                    />
                    <div className="info-estado-opendata">
                      <label className="title-info-opendata-section-one">
                        Estado
                      </label>
                      <div className="container-white-estado">
                        <p>Terminado</p>
                      </div>
                    </div>
                  </div>
                  <div className="info-section-one">
                    <label className="title-info-opendata-section-one">
                      Calificación
                    </label>
                    <div className="calificacion-info-open-data">
                      {metadato?.calificacion ? (
                        <Rating
                          idRegistro={metadato?.id_fuente_dato}
                          route={"opendata/calificacion"}
                          numCalificacion={metadato.num_calificacion}
                          key={metadato.id_aplicacion}
                          origen={"datosabiertos"}
                        />
                      ) : null}
                      {metadato?.calificacion ? (
                        <span>{`${metadato?.porcentaje}%`}</span>
                      ) : (
                        ""
                      )}
                      {/* <p>
                        {descargas.length > 0
                          ? `${descargas[0].total} descargas`
                          : `0 descargas`}
                      </p> */}
                    </div>
                  </div>
                  <div className="info-section-one">
                    <label className="title-info-opendata-section-one">
                      Visitas al dato abierto
                    </label>
                    <p>{visitas.length > 0 ? `${visitas[0].total}` : `0`}</p>
                  </div>
                  <div className="info-section-one">
                    <label className="title-info-opendata-section-one">
                      Fecha de creación
                    </label>
                    <p>{metadato?.atributo_fechaCreacion}</p>
                  </div>
                  <div className="info-section-one">
                    <label className="title-info-opendata-section-one">
                      Fecha de Actualización
                    </label>
                    <p>{metadato?.atributo_fechaActualizado}</p>
                  </div>
                  <div className="info-section-one">
                    <div className="flex-tarjetas-app">
                      <label className="title-info-opendata-section-one">
                        Descargar formatos:
                      </label>
                      <span className="lbl-opendata-card-forma-descargas">
                        {descargas.length > 0 ? (
                          <>
                            {`${descargas[0].total}`}
                            <p>Total de descargas</p>
                          </>
                        ) : (
                          <>
                            {`0`}
                            <p>Total de descargas</p>
                          </>
                        )}
                      </span>
                    </div>
                    <br />
                    {metadato?.formatos
                      ?.split("/--/")
                      .map((formato = [], index = 0, arrayFormatos = []) => {
                        return (
                          <>
                            <a
                              href={
                                urlDescargaFormatos(
                                  formato,
                                  metadato.id_servicio
                                )
                                // formato.split("--")[3]
                                //   ? `${URL_IMAGE_GEOMEDELLIN}/openDataExt/${
                                //       formato.split("--")[3]
                                //     }`
                                //   : false
                              }
                              rel={"noreferrer"}
                              download={
                                formato?.split("--")?.[3] ? true : false
                              }
                              className="lbl-opendata-card-forma"
                              onClick={async () => {
                                const nombreArchivo = formato?.split("--")?.[3];

                                if (nombreArchivo) {
                                  // guardarUbicacion(
                                  //   "2",
                                  //   "1",
                                  //   metadato?.id_fuente_dato
                                  // );

                                  const numberDowonload =
                                    await registrarEstadistica({
                                      idFuenteDato: metadato?.id_fuente_dato,
                                      tipoEstadistica: 1,
                                      idUsuario: infoUser,
                                      formato: formato.split("--")[1],
                                      origen: 1,
                                    });

                                  setDescargas(numberDowonload);

                                  return;
                                }
                                return;
                              }}
                            >
                              {formato?.split("--")?.[2]}
                            </a>
                            {arrayFormatos?.length - 1 === index ? (
                              ""
                            ) : (
                              <label className="lbl-barra-inclinada-formato-opendata">
                                /
                              </label>
                            )}
                          </>
                        );
                      })}
                  </div>
                  {metadato?.url_servicio ? (
                    <div className="info-section-one">
                      <label className="title-info-opendata-section-one">
                        Url servicio
                      </label>
                      <Form.Control
                        name="descripcion"
                        as="textarea"
                        disabled={true}
                        value={metadato?.url_servicio}
                        className="inputs-forms-admin focus-admin-register textarea-form-admin"
                        style={{
                          lineHeight: "1.2rem",
                          height: "4rem",
                          resize: "none",
                        }}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="info-section-one-actions mt-4">
                    {/* <FcDownload
                      color="
                  #004884"
                      size={"25px"}
                      className=" cursor-pointer"
                    />
                    <AiOutlineShareAlt
                      color="
                  #004884"
                      size={"25px"}
                      className="ms-3 cursor-pointer"
                    /> */}
                    <div className="container-flex-button-metadato">
                      {metadato.has_shape &&
                      !metadato?.url_servicio &&
                      dataUser.idUsuario !== 0 ? (
                        <button
                          style={{ marginRight: "10px" }}
                          type="button"
                          onClick={(e) => obtenerUrl(e)}
                          className="btn-geomedellin btn-metadato btn-accion btn btn-primary"
                        >
                          Solicitar URL
                        </button>
                      ) : (
                        <></>
                      )}

                      <button
                        type="button"
                        className="btn-geomedellin btn-metadato btn-accion btn btn-primary"
                        onClick={() => {
                          redireccionMetadato(
                            `https://www.medellin.gov.co/giscatalogacion/srv/spa/catalog.search#/metadata/${openDataInfo?.[0]?.uuid}`,
                            openDataInfo?.[0]?.uuid
                          );
                        }}
                      >
                        Ir al metadato
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
            {openDataInfo.map((metadato) => {
              return (
                <div
                  className="grid-container-section-two"
                  key={metadato?.id_opendata}
                >
                  <div className="flex-container-info">
                    <div className="container-description">
                      <label className="title-info-opendata-section-two">
                        {metadato?.nombre}
                      </label>
                      <p className="mt-2 text-descripcion_infoOpenData">
                        {metadato?.descripcion}
                      </p>
                    </div>
                    <div className="container-info-sections mt-4">
                      <div className="info-section">
                        <label className="title-info-opendata-section-two">
                          Categorías
                        </label>
                        <p className="mt-2">
                          {metadato?.atributo_categorias?.join("/ ")}
                        </p>
                      </div>
                      <div className="info-section">
                        <label className="title-info-opendata-section-two">
                          Categorías MinTic
                        </label>
                        <p className="mt-2">
                          {metadato?.atributo_categoriaMinTIC}
                        </p>
                      </div>
                    </div>
                    <div className="container-info-sections mt-4">
                      <div className="info-section">
                        <label className="title-info-opendata-section-two">
                          Plabras claves
                        </label>
                        <p className="mt-2">
                          {metadato?.atributo_palabrasClaves?.join("/ ")}
                        </p>
                      </div>
                      <div
                        className="info-section text-infoOpenData"
                        title={metadato?.atributo_creditos}
                      >
                        <label className="title-info-opendata-section-two">
                          Créditos
                        </label>
                        <p className="mt-2">{metadato?.atributo_creditos}</p>
                      </div>
                    </div>
                    <div className="container-description">
                      <label className="title-info-opendata-section-two">
                        Contacto
                      </label>
                      <div className="info-section mt-2">
                        <label className="title-info-opendata-section-two-contacto">
                          {metadato?.atributo_contacto?.organizacion ??
                            "Alcaldía de Medellín - Secretaría de innovación Digital"}
                        </label>
                        <p className="mt-2">
                          {metadato?.atributo_contacto?.direccion}
                          {metadato?.atributo_contacto?.ciudad
                            ? ", " + metadato?.atributo_contacto?.ciudad
                            : ""}
                          {metadato?.atributo_contacto?.departamento
                            ? ", " + metadato?.atributo_contacto?.departamento
                            : ""}
                          {metadato?.atributo_contacto?.postalCode
                            ? ", " + metadato?.atributo_contacto?.postalCode
                            : ""}
                        </p>
                        <label className="title-info-opendata-section-two-contacto">
                          Punto de Contacto:
                        </label>
                        <label className="title-info-opendata-section-two-contacto">
                          {metadato?.atributo_contacto?.responsable}
                        </label>
                        <p className="mt-2">
                          {metadato?.atributo_contacto?.email} <br></br>
                          {metadato?.atributo_contacto?.telefonoExt}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Container>
        <Load visible={load} />
      </Container>
      <PiePagina fluid={true} />
    </>
  );
};
